<template>
  <div>
    <section v-if="showMeettheCandidates" :ballot-data="ballotData" class="start__screen-module">
      <v-meetthecandidates :ballot-data="ballotData" />
    </section>

    <section v-if="showBallotPage" class="rcv__ballot-section">
      <div class="container">
        <div class="rcv__heading-v1">
          <h1>{{ ['seeNextError', 'tryRankingAgain'].includes(footerState) ? ballotData.submittedBallotHeading :
            ballotData.ballotHeading }}</h1>
        </div>
        <div class="rcv__choice-grid">
          <div class="rcv__choice-left">
            <div class="rcv__choice-wrapp">
              <div class="rcv__choice-head">
                <div v-for="(column, index) in ballotData.columnHeaders" :key="index" class="rcv__choice-col">
                  <span>{{ column.columnHeader }}</span>
                </div>
              </div>
              <div v-for="(candidate, rowIndex) in ballotData.listOfAnimals" :key="rowIndex" class="rcv__choice-row">
                <div :class="['rcv__choice-avatar', getCandidateColorClass(candidate.color)]" :alt="candidate.altText">
                  <img   :src="candidate.image" alt="" width="60" height="60">

                </div>
                <!-- <div v-for="(column, colIndex) in ballotData.columnHeaders" tabindex="0" :key="colIndex" class="rcv__choice-col"> -->
                <div v-for="(column, colIndex) in ballotData.columnHeaders" :key="colIndex" class="rcv__choice-col"
                  >
                  <label :for="`choice-${rowIndex}-${colIndex}`" :aria-label="`Select ${column.columnHeader} ${candidate.animalCandidateName}`" tabindex="0" class="rcv__choice-box"  
                    :class="{ 'rcv__error': hasError(rowIndex, colIndex), 'rcv__choice-disabled': footerState === 'seeNextError' || footerState === 'tryRankingAgain' }">
                    <input  type="checkbox" :id="`choice-${rowIndex}-${colIndex}`" :checked="isChecked(rowIndex, colIndex)"  :aria-checked="isChecked(rowIndex, colIndex) ? 'true' : 'false'"
                      @change="handleSelection(rowIndex, colIndex)"  hidden>

                    <span   class="rcv__choice-checkmark" aria-hidden="true">
                      <svg width="35" height="22" viewBox="0 0 35 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M2.06327 13.6747C2.20896 13.8057 8.69797 1.28287 10.6175 3.03421C10.7122 3.12033 4.7226 17.1526 4.7226 17.1526C8.09418 20.2257 15.1484 0.130537 17.0288 1.84537C17.6537 2.41449 7.2777 18.0985 8.57132 19.2779L22.4228 2.04922C22.4228 2.04922 12.2008 19.7416 12.7437 20.2358C14.6888 22.0096 23.6896 0.625251 26.4708 3.161C27.871 4.43498 17.6654 19.8797 18.0927 20.27C18.0927 20.27 29.4244 4.80601 30.0611 5.38357C30.3626 5.65783 24.3645 18.9511 24.3645 18.9511C25.8822 20.3346 32.1642 8.62037 32.4565 8.88528"
                          stroke="#221649" stroke-width="3.17277" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="rcv__choice-right">
            <div class="rcv__choice-message" v-if="successMessage">
              <p> <span><svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M15.6172 31C24.1776 31 31.1172 24.0604 31.1172 15.5C31.1172 6.93959 24.1776 0 15.6172 0C7.05677 0 0.117188 6.93959 0.117188 15.5C0.117188 24.0604 7.05677 31 15.6172 31ZM6.39262 16.9766L12.5054 23.3522C12.8727 23.7353 13.4681 23.7353 13.8354 23.3523L24.6503 12.0722C25.0176 11.6892 25.0176 11.0681 24.6503 10.6851L23.3204 9.29791C22.9532 8.91488 22.3577 8.91488 21.9904 9.29791L13.1704 18.4972L9.05253 14.2023C8.68529 13.8192 8.0898 13.8192 7.72256 14.2023L6.39262 15.5894C6.02538 15.9725 6.02538 16.5935 6.39262 16.9766Z"
                      fill="#FDF751" />
                  </svg></span>{{ successMessage }}</p>
            </div>

            <div class="rcv__choice-message rcv__choice-message--alert" v-for="(error, index) in orderedErrors"
              :key="index">
              <p>
                <span>
                  <svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M16.0293 31C24.5897 31 31.5293 24.0604 31.5293 15.5C31.5293 6.93959 24.5897 0 16.0293 0C7.46888 0 0.529297 6.93959 0.529297 15.5C0.529297 24.0604 7.46888 31 16.0293 31ZM15.3791 17.98H16.6791L17.5991 12.18V9H14.4391V12.18L15.3791 17.98ZM14.3591 23H17.6791V19.86H14.3591V23Z"
                      fill="#FDF751" />
                  </svg>
                </span>
                {{ error.message }}
              </p>
            </div>
            <div class="rcv__choice-message rcv__choice-message--alert" v-if="isNoBubblesSelectedError">
              <p> <span><svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M16.0293 31C24.5897 31 31.5293 24.0604 31.5293 15.5C31.5293 6.93959 24.5897 0 16.0293 0C7.46888 0 0.529297 6.93959 0.529297 15.5C0.529297 24.0604 7.46888 31 16.0293 31ZM15.3791 17.98H16.6791L17.5991 12.18V9H14.4391V12.18L15.3791 17.98ZM14.3591 23H17.6791V19.86H14.3591V23Z"
                      fill="#FDF751" />
                  </svg>
                </span> {{ ballotData.rcvNoBubblesAreFilledDescription }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-if="showErrorPage" class="start__screen-module">
      <v-errorPage :ballot-data="ballotData" />
    </section>

    <section v-if="showSuccessPage" class="start__screen-module rcv__success-module">
      <v-successpage :ballot-data="ballotData" :sorted-selections="sortedSelections" />
    </section>

    <v-footer :ballot-data="ballotData" :current-state="footerState" :show-back-button="showBackButton"
      @start-clicked="handleStart" @proceed-clicked="handleProceed" @submit-clicked="handleFinalSubmit"
      @see-errors-clicked="seeErrors" @back-clicked="handleBack" @see-next-error-clicked="handleNextError"
      @try-ranking-again="rankingAgain" @how-votes-counted-clicked="howVotesCounted" />

  </div>
</template>

<script>
import axios from 'axios';
import MeettheCandidatesComponent from "./components/MeetTheCandidatesComponent";
import ErrorPageComponent from "./components/ErrorPageComponent";
import SuccessPageComponent from "./components/SuccessPageComponent";
import FooterComponent from "./components/FooterComponent";

export default {
  name: "PracticeBallotV2",
  inject: ['rcvV2PageId'],
  data() {
    return {
      ballotData: null,
      loading: true,
      error: null,
      showPracticeBallot: false,
      selectedGrid: [],
      rowError: null,
      colError: null,
      columnGapError: null,
      successMessage: null,
      isBallotSubmitted: false,
      isError: false,
      showMeettheCandidates: false,
      showBallotPage: false,
      showErrorPage: false,
      showSuccessPage: false,
      footerState: 'initial',
      showBackButton: false,
      errorRows: [],
      errorCols: [],
      columnGaps: [],
      emptyBallot: false,
      currentErrorType: null,
      isLastError: false,
      shownoBubblesSelectedError: null,
      isNoBubblesSelectedError: false,
      orderedErrors: []

    };
  },
  computed: {

    sortedSelections() {
      const selections = [];

      // For each column (rank)
      for (let colIndex = 0; colIndex < this.ballotData.columnHeaders.length; colIndex++) {
        // Find which candidate (row) was selected for this rank
        for (let rowIndex = 0; rowIndex < this.selectedGrid.length; rowIndex++) {
          if (this.selectedGrid[rowIndex] && this.selectedGrid[rowIndex][colIndex]) {
            // Add this candidate with their rank
            selections.push({
              candidate: this.ballotData.listOfAnimals[rowIndex],
              rank: colIndex
            });
            break; // Only one selection per column is valid
          }
        }
      }

      // Sort by rank (should already be sorted, but just to be sure)
      return selections.sort((a, b) => a.rank - b.rank);
    }
  },
  components: {
    "v-meetthecandidates": MeettheCandidatesComponent,
    "v-errorPage": ErrorPageComponent,
    "v-successpage": SuccessPageComponent,
    "v-footer": FooterComponent
  },
  methods: {
    howVotesCounted() {
      const url = this.ballotData.seeHowVotesAreCounted;
      if (url) {
        window.location.href = url; // or use `window.open(url, '_blank')` to open in new tab
      }
    },
    removeError(type) {
      this.orderedErrors = this.orderedErrors.filter(err => err.type !== type);
    },
    addError(type, message) {
      // Prevent duplicates
      if (!this.orderedErrors.find(err => err.type === type)) {
        this.orderedErrors.unshift({ type, message });
      }
    },
    getCandidateColorClass(color) {
      const colorClassMap = {
        "#fdf751": "rcv__choice-color-2",
        "#221649": "rcv__choice-color-4",
        "#4ba3b7": "rcv__choice-color-1",
        "#ed7aca": "rcv__choice-color-3",
        "#eb5534": "rcv__choice-color-5",
        "#367d54": "rcv__choice-color-6"
      };

      return colorClassMap[color] || "rcv__choice-color-6"; // default class
    },
    rankingAgain() {
      this.isNoBubblesSelectedError = false;
      this.footerState = 'readyToSubmit';
      this.clearBallotSelections();
      this.clearErrors();
      this.isLastError = false;
    },
    handleNextError() {
      // Define the order of error types to cycle through
      const errorTypes = ['empty', 'row', 'column', 'gap'];

      // Create a filtered list of active error types
      const activeErrorTypes = [];
      if (this.emptyBallot) activeErrorTypes.push('empty');
      if (this.errorRows.length > 0) activeErrorTypes.push('row');
      if (this.errorCols.length > 0) activeErrorTypes.push('column');
      if (this.columnGaps.length > 0) activeErrorTypes.push('gap');

      if (activeErrorTypes.length === 0) return; // No errors to show

      // Find the current index
      const currentIndex = activeErrorTypes.indexOf(this.currentErrorType);

      // Move to the next error type
      const nextIndex = (currentIndex + 1) % activeErrorTypes.length;
      this.currentErrorType = activeErrorTypes[nextIndex];
      // Check if this is the last error
      this.isLastError = nextIndex === activeErrorTypes.length - 1;
      if (this.isLastError === true) {
        this.footerState = 'tryRankingAgain';
      }
      // Focus on the current error type
      this.$nextTick(() => {
        this.focusOnCurrentErrorType();
      }
      );

    },
    hasError(rowIndex, colIndex) {
      // Only highlight errors when we're in error viewing mode
      if (this.footerState !== 'submittedError' && this.footerState !== 'seeNextError' && this.footerState !== 'tryRankingAgain') {
        return false;
      }

      // Empty ballot case - highlight all cells
      if (this.currentErrorType === 'empty' && this.emptyBallot) {
        return true;
      }

      // Row error - highlight only cells in the error rows that are selected
      if (this.currentErrorType === 'row' &&
        this.errorRows.includes(rowIndex) &&
        this.selectedGrid[rowIndex][colIndex]) {
        return true;
      }

      // Column error - highlight only cells in the error columns that are selected
      if (this.currentErrorType === 'column' &&
        this.errorCols.includes(colIndex) &&
        this.selectedGrid[rowIndex][colIndex]) {
        return true;
      }

      // Gap error - highlight only the gap columns
      if (this.currentErrorType === 'gap' && this.columnGaps.includes(colIndex)) {
        return true;
      }

      return false;
    },
    seeErrors() {
      this.footerState = 'seeNextError';
      this.showErrorPage = false;
      this.showBallotPage = true;

      // Reset error arrays
      this.errorRows = [];
      this.errorCols = [];
      this.columnGaps = [];
      this.emptyBallot = false;

      // Check if there are no selections at all
      const hasAnySelection = this.selectedGrid.some(row =>
        row && row.some(cell => cell === true)
      );

      if (!hasAnySelection) {
        // Mark the ballot as empty to highlight all cells
        this.footerState = 'tryRankingAgain';
        this.emptyBallot = true;
        this.currentErrorType = 'empty';
        this.isNoBubblesSelectedError = true
        return;
      }

      // Check for row errors - rows with multiple selections
      for (let rowIndex = 0; rowIndex < this.selectedGrid.length; rowIndex++) {
        const row = this.selectedGrid[rowIndex];
        if (row) {
          const rowSelections = row.filter(Boolean).length;
          if (rowSelections > 1) {
            this.errorRows.push(rowIndex);
          }
        }
      }

      // Check for column errors - columns with multiple selections
      const columnCount = this.ballotData.columnHeaders.length;
      for (let colIndex = 0; colIndex < columnCount; colIndex++) {
        let colSelections = 0;
        for (let rowIndex = 0; rowIndex < this.selectedGrid.length; rowIndex++) {
          if (this.selectedGrid[rowIndex] && this.selectedGrid[rowIndex][colIndex]) {
            colSelections++;
          }
        }
        if (colSelections > 1) {
          this.errorCols.push(colIndex);
        }
      }

      // Check for column gaps
      const selectedColumns = Array(columnCount).fill(false);
      this.selectedGrid.forEach(row => {
        if (row) {
          row.forEach((isSelected, index) => {
            if (isSelected) {
              selectedColumns[index] = true;
            }
          });
        }
      });

      const firstSelected = selectedColumns.findIndex(val => val);
      const lastSelected = selectedColumns.lastIndexOf(true);

      // Modified gap checking logic
      if (firstSelected !== -1) { // Only if there's at least one selection
        // If first column isn't selected but a later column is
        if (firstSelected > 0) {
          // Add all columns from 0 to firstSelected-1 as gaps
          for (let i = 0; i < firstSelected; i++) {
            this.columnGaps.push(i);
          }
        }

        // Check for gaps between first and last selected
        if (lastSelected > firstSelected) {
          for (let i = firstSelected + 1; i < lastSelected; i++) {
            if (!selectedColumns[i]) {
              this.columnGaps.push(i);
            }
          }
        }
      }

      if (
        this.errorRows.length === 0 &&
        this.errorCols.length === 0 &&
        this.columnGaps.length > 0
      ) {
        this.footerState = 'tryRankingAgain';
        this.currentErrorType = 'gap';
        return;
      }
      // Count the number of different error types present
      const errorTypes = [
        this.errorRows.length > 0,
        this.errorCols.length > 0,
        this.columnGaps.length > 0
      ];
      const totalErrorTypes = errorTypes.filter(Boolean).length;

      // If there's only one type of error, set footerState to 'tryRankingAgain'
      if (totalErrorTypes === 1) {
        this.footerState = 'tryRankingAgain';
      }

      // Set the initial error type to focus on
      if (this.errorRows.length > 0) {
        this.currentErrorType = 'row';
      } else if (this.errorCols.length > 0) {
        this.currentErrorType = 'column';
      } else if (this.columnGaps.length > 0) {
        this.currentErrorType = 'gap';
      }
      // On the next tick, after the DOM is updated, focus on the first error
      this.$nextTick(() => {
        this.focusOnCurrentErrorType();
      });
    },
    focusOnCurrentErrorType() {
      let selector;

      // Clear all previously added errors to show only the current one
      this.orderedErrors = [];

      if (this.currentErrorType === 'empty') {
        selector = '.rcv__choice-box:first-child';
        this.addError('empty', this.ballotData.noBubblesSelected);
      }

      else if (this.currentErrorType === 'row' && this.errorRows.length > 0) {
        const rowIndex = this.errorRows[0];
        let colIndex = 0;
        if (this.selectedGrid[rowIndex]) {
          colIndex = this.selectedGrid[rowIndex].findIndex(cell => cell === true);
          if (colIndex === -1) colIndex = 0;
        }
        selector = `.rcv__choice-row:nth-child(${rowIndex + 1}) .rcv__choice-col:nth-child(${colIndex + 1}) .rcv__choice-box`;
        this.addError('row', this.ballotData.moreThanOneBubbleSelectedInARow);
      }

      else if (this.currentErrorType === 'column' && this.errorCols.length > 0) {
        const colIndex = this.errorCols[0];
        let rowIndex = 0;
        for (let i = 0; i < this.selectedGrid.length; i++) {
          if (this.selectedGrid[i] && this.selectedGrid[i][colIndex]) {
            rowIndex = i;
            break;
          }
        }
        selector = `.rcv__choice-row:nth-child(${rowIndex + 1}) .rcv__choice-col:nth-child(${colIndex + 1}) .rcv__choice-box`;
        this.addError('column', this.ballotData.rcvMore1BubbleInAColDescription);
      }

      else if (this.currentErrorType === 'gap' && this.columnGaps.length > 0) {
        const colIndex = this.columnGaps[0];
        selector = `.rcv__choice-row:first-child .rcv__choice-col:nth-child(${colIndex + 1}) .rcv__choice-box`;
        this.addError('gap', this.ballotData.gapBetweenColumnsValidationDescription);
      }

      // Focus on the corresponding UI element
      // if (selector) {
      //   this.$nextTick(() => {
      //     // debugger;
      //     const errorElement = document.querySelector(selector);
      //     if (errorElement) {
      //       errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      //       errorElement.focus();
      //     }
      //   });
      // }
    },
    clearErrors() {
      this.errorRows = [];
      this.errorCols = [];
      this.columnGaps = [];
      this.currentErrorType = null;
      this.emptyBallot = false;
      this.rowError = null;
      this.colError = null;
      this.columnGapError = null;
      this.orderedErrors = [];

    },
    clearBallotSelections() {
      if (this.ballotData) {
        const newGrid = Array(this.ballotData.listOfAnimals.length)
          .fill(null)
          .map(() => Array(this.ballotData.columnHeaders.length).fill(false));

        this.$set(this, 'selectedGrid', newGrid);
      }
    },
    getCurrentPage() {
      if (this.showSuccessPage) return 'success';
      if (this.showErrorPage) return 'error';
      if (this.showBallotPage) return 'ballot';
      if (this.showMeettheCandidates) return 'meetCandidates';
      return 'initial';
    },
    handleBack() {
      this.rowError = null;
      this.colError = null;
      this.columnGapError = null;
      this.successMessage = null;

      // Handle back button when viewing errors
      if (this.footerState === 'seeNextError' || this.footerState === 'tryRankingAgain') {
        // Get the current error types in reverse order for proper back navigation
        const errorTypes = ['empty', 'row', 'column', 'gap'].filter(type => {
          if (type === 'empty') return this.emptyBallot;
          if (type === 'row') return this.errorRows.length > 0;
          if (type === 'column') return this.errorCols.length > 0;
          if (type === 'gap') return this.columnGaps.length > 0;
          return false;
        });

        if (errorTypes.length === 0) {
          // If no errors to navigate back to, return to the ballot page
          this.footerState = 'readyToSubmit';
          return;
        }

        // Find the current index
        const currentIndex = errorTypes.indexOf(this.currentErrorType);

        if (currentIndex <= 0) {
          // If at the first error or no current error, go back to error page
          this.showErrorPage = true;
          this.showBallotPage = false;
          this.footerState = 'submittedError';
        } else {
          // Go to the previous error type
          this.currentErrorType = errorTypes[currentIndex - 1];
          this.isLastError = false;
          this.footerState = 'seeNextError'; // Ensure footer state is consistent

          // Focus on the previous error type
          this.$nextTick(() => {
            this.focusOnCurrentErrorType();
          });
        }
        return;
      }

      // Handle other states as before
      if (this.showSuccessPage) {
        this.showSuccessPage = false;
        this.showBallotPage = true;
        this.footerState = 'readyToSubmit';
        this.clearBallotSelections();
        return;
      }

      if (this.showErrorPage) {
        // debugger;
        this.showErrorPage = false;
        this.showBallotPage = true;
        this.footerState = 'readyToSubmit';
        this.validateSelections();
        this.removeError('columnGap');
        this.isNoBubblesSelectedError = false;
        this.columnGaps = [];

      } else if (this.showBallotPage) {
        this.showBallotPage = false;
        this.showMeettheCandidates = true;
        this.footerState = 'rankingStarted';
      } else if (this.showMeettheCandidates) {
        this.showMeettheCandidates = false;
        this.footerState = 'initial';
        this.showBackButton = false;
      }
    },
    handleStart() {
      this.footerState = 'rankingStarted';
      this.showBackButton = true;
      this.showMeettheCandidates = true;
    },
    handleProceed() {
      this.clearBallotSelections();
      this.clearErrors();
      this.footerState = 'readyToSubmit';
      this.showBallotPage = true;
      this.showMeettheCandidates = false;
    },
    handleFinalSubmit() {

      this.rowError = null;
      this.colError = null;
      this.columnGapError = null;
      this.successMessage = null;
      // Check if there are no selections at all
      const hasAnySelection = this.selectedGrid.some(row =>
        row && row.some(cell => cell === true)
      );

      if (!hasAnySelection) {
        this.isError = true;
        this.footerState = 'submittedError';
        this.showErrorPage = true;
        this.showBallotPage = false;
        this.showSuccessPage = false;
        return;
      }

      const isValid = this.validateSelections();
      const gapIsValid = this.checkColumnGapError();

      if (!isValid || !gapIsValid) {
        this.footerState = 'submittedError';
        this.showErrorPage = true;
        this.showBallotPage = false;
        this.showSuccessPage = false;
      } else {
        this.showBackButton = false;
        this.footerState = 'submittedSuccess'; // Set explicitly
        this.showSuccessPage = true;
        this.showBallotPage = false;
        this.showErrorPage = false;
      }
    },
    checkColumnGapError() {
      const columnCount = this.ballotData.columnHeaders.length;
      const selectedColumns = Array(columnCount).fill(false);

      this.selectedGrid.forEach(row => {
        if (row) {
          row.forEach((isSelected, index) => {
            if (isSelected) {
              selectedColumns[index] = true;
            }
          });
        }
      });

      const firstSelected = selectedColumns.findIndex(val => val);
      const lastSelected = selectedColumns.lastIndexOf(true);

      if (firstSelected !== -1 && lastSelected !== -1) {
        for (let i = firstSelected; i <= lastSelected; i++) {
          if (!selectedColumns[i]) {
            this.addError('columnGap', this.ballotData.gapBetweenColumnsValidationDescription);
            return false;
          }
        }
      }

      // If column 0 is not selected but other columns are
      if (!selectedColumns[0] && selectedColumns.some((val, index) => index > 0 && val)) {
        this.addError('columnGap', this.ballotData.gapBetweenColumnsValidationDescription);
        return false;
      }

      // ✅ All good — explicitly return true
      return true;
    },
    getBallotData() {
      //let pageId = 4886; 
      let pageId = window.rcvV2PageId;

      axios.get(`${location.origin}/v2practicercv/getballotData?id=${pageId}`)
     // axios.get(`http://localhost:63238/v2practicercv/getballotData?id=4886`)
     //axios.get(`https://votingnycdev-v13-frontend-qa.azurewebsites.net/v2practicercv/getballotData?id=2248`)
        .then(response => {
          this.ballotData = response.data;
          // Initialize selection grid
          this.selectedGrid = Array(this.ballotData.listOfAnimals.length)
            .fill(null)
            .map(() => Array(this.ballotData.columnHeaders.length).fill(false));
        })
        .catch(error => {
          this.error = 'Failed to load ballot data';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isChecked(rowIndex, colIndex) {
      return this.selectedGrid[rowIndex] && this.selectedGrid[rowIndex][colIndex] === true;
    },
    validateSelections() {
      let hasRowError = false;
      let hasColError = false;
      // let hasColumnGapError = false;

      // ----- ROW ERROR CHECK -----
      let foundRowError = false;
      for (let rowIndex = 0; rowIndex < this.selectedGrid.length; rowIndex++) {
        const row = this.selectedGrid[rowIndex];
        if (row) {
          const rowSelections = row.filter(Boolean).length;
          if (rowSelections > 1) {
            this.rowError = this.ballotData.moreThanOneBubbleSelectedInARow;
            this.addError('row', this.rowError);
            hasRowError = true;
            foundRowError = true;
            break;
          }
        }
      }
      if (!foundRowError) {
        this.rowError = '';
        this.removeError('row');
      }

      // ----- COLUMN ERROR CHECK -----
      let foundColError = false;
      const columnCount = this.ballotData.columnHeaders.length;
      for (let colIndex = 0; colIndex < columnCount; colIndex++) {
        let colSelections = 0;
        for (let rowIndex = 0; rowIndex < this.selectedGrid.length; rowIndex++) {
          if (this.selectedGrid[rowIndex] && this.selectedGrid[rowIndex][colIndex]) {
            colSelections++;
          }
        }
        if (colSelections > 1) {
          this.colError = this.ballotData.rcvMore1BubbleInAColDescription;
          this.addError('column', this.colError);
          hasColError = true;
          foundColError = true;
          break;
        }
      }
      if (!foundColError) {
        this.colError = '';
        this.removeError('column');
      }
      return !(hasRowError || hasColError);
    },
    handleSelection(rowIndex, colIndex) {
      // If we're in error review mode, don't allow selection changes
      if (this.footerState === 'seeNextError' || this.footerState === 'tryRankingAgain') {
        return;
      }
      // Reset success message
      this.successMessage = null;

      // Initialize row if it doesn't exist
      if (!this.selectedGrid[rowIndex]) {
        this.$set(this.selectedGrid, rowIndex, []);
      }

      // Toggle current selection
      const current = this.selectedGrid[rowIndex][colIndex];
      this.$set(this.selectedGrid[rowIndex], colIndex, !current);

      // Reset error messages
      this.rowError = null;
      this.colError = null;
      this.columnGapError = null;

      // Check if there are any selections at all
      const hasAnySelection = this.selectedGrid.some(row =>
        row && row.some(cell => cell === true)
      );

      if (!hasAnySelection) {
        this.successMessage = null;
        return;
      }
      const isValid = this.validateSelections();

      if (isValid) {
        const totalSelections = this.selectedGrid.reduce((acc, row) => {
          if (!row) return acc;
          return acc + row.filter(cell => cell === true).length;
        }, 0);

        if (totalSelections === 1) {
          this.successMessage = this.ballotData.success;
        } else if (totalSelections === 5) {

          this.successMessage = this.ballotData.selectionCompletedMessage;
        }
        else {
          this.successMessage = false;
        }

      }

    },
    setupChoiceBoxes() {
      this.$nextTick(() => {
        const choiceBoxes = document.querySelectorAll(".rcv__choice-box");
        const isMobile = window.innerWidth <= 768; // Check if it's mobile view

        if (choiceBoxes && choiceBoxes.length > 0) {
          choiceBoxes.forEach((box, index) => {
            const checkbox = box.querySelector("input[type='checkbox']");
            if (!checkbox) return;

            // Clean up old event listeners to prevent duplicates
            if (box._clickHandler) {
              box.removeEventListener("click", box._clickHandler);
            }
            if (checkbox._changeHandler) {
              checkbox.removeEventListener("change", checkbox._changeHandler);
            }
            if (box._keydownHandler) {
              box.removeEventListener("keydown", box._keydownHandler);
            }
            // Get the row and column indices
            const currentRow = box.closest('.rcv__choice-row');
            const currentCol = box.closest('.rcv__choice-col');
            const rowIndex = Array.from(currentRow.parentElement.children).indexOf(currentRow) - 1; // -1 to account for header
            const colIndex = Array.from(currentRow.children).indexOf(currentCol) - 1; // -1 to account for avatar

            // Get the candidate name and column header
            const candidateName = this.ballotData.listOfAnimals[rowIndex].animalCandidateName;
            const columnHeader = this.ballotData.columnHeaders[colIndex].columnHeader;
           // const ariaLabel = `Select ${columnHeader} ${candidateName}`;

            // Set the ARIA label
           // checkbox.setAttribute("aria-label", ariaLabel);

            // Move ARIA attributes to the checkbox input instead of the wrapper
            //checkbox.setAttribute("aria-label", `Select option ${index + 1}`);
            checkbox.setAttribute("aria-disabled", box.classList.contains("rcv__choice-disabled") ? "true" : "false");

            // Remove invalid ARIA attributes from wrapper
            box.removeAttribute("role");
            box.removeAttribute("aria-checked");
            box.removeAttribute("aria-disabled");
            // box.removeAttribute("aria-label");

            // Change handler for the checkbox
            const changeHandler = (event) => {
              // Update ARIA attributes
              box.setAttribute("aria-checked", checkbox.checked);

              // Trigger auto-scroll only on mobile
              if (isMobile && checkbox.checked) {
                // Important: Use setTimeout to ensure DOM has updated
                setTimeout(() => {
                  const choiceRow = box.closest('.rcv__choice-row');
                  if (choiceRow) {
                    const avatar = choiceRow.querySelector('.rcv__choice-avatar');
                    if (avatar) {
                      avatar.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                  }
                }, 50);
              }
            };

            // Add change event listener
            checkbox.addEventListener("change", changeHandler);
            checkbox._changeHandler = changeHandler;

            // Click handler for the box
            const clickHandler = (event) => {
              if (event.target === checkbox) {
                return;
              }
              event.preventDefault();
              checkbox.checked = !checkbox.checked;
              const changeEvent = new Event("change", { bubbles: true });
              checkbox.dispatchEvent(changeEvent);
            };

            // Add click event listener
            box.addEventListener("click", clickHandler);
            box._clickHandler = clickHandler;

            if (!box.hasAttribute("tabindex")) {
              box.setAttribute("tabindex", "0");
            }

            // Keyboard navigation handler
            const keydownHandler = (event) => {
              const key = event.key;
              const currentRow = box.closest('.rcv__choice-row');
              const currentCol = box.closest('.rcv__choice-col');

              switch (key) {
                case 'Enter':
                case ' ':
                  event.preventDefault();
                  if (!box.classList.contains("rcv__choice-disabled")) {
                    checkbox.checked = !checkbox.checked;
                    box.setAttribute("aria-checked", checkbox.checked);
                    const changeEvent = new Event("change", { bubbles: true });
                    checkbox.dispatchEvent(changeEvent);
                  }
                  break;

                case 'ArrowUp':
                  event.preventDefault();
                  const prevRow = currentRow.previousElementSibling;
                  if (prevRow) {
                    const prevBox = prevRow.querySelector(`.rcv__choice-col:nth-child(${Array.from(currentRow.children).indexOf(currentCol) + 1}) .rcv__choice-box`);
                    if (prevBox) prevBox.focus();
                  }
                  break;

                case 'ArrowDown':
                  event.preventDefault();
                  const nextRow = currentRow.nextElementSibling;
                  if (nextRow) {
                    const nextBox = nextRow.querySelector(`.rcv__choice-col:nth-child(${Array.from(currentRow.children).indexOf(currentCol) + 1}) .rcv__choice-box`);
                    if (nextBox) nextBox.focus();
                  }
                  break;

                case 'ArrowLeft':
                  event.preventDefault();
                  const prevCol = currentCol.previousElementSibling;
                  if (prevCol && prevCol.classList.contains('rcv__choice-col')) {
                    const prevBox = prevCol.querySelector('.rcv__choice-box');
                    if (prevBox) prevBox.focus();
                  }
                  break;

                case 'ArrowRight':
                  event.preventDefault();
                  const nextCol = currentCol.nextElementSibling;
                  if (nextCol && nextCol.classList.contains('rcv__choice-col')) {
                    const nextBox = nextCol.querySelector('.rcv__choice-box');
                    if (nextBox) nextBox.focus();
                  }
                  break;
              }
            };

            // Add keydown event listener
            box.removeEventListener("keydown", box._keydownHandler); // Remove old listener
            box.addEventListener("keydown", keydownHandler);
            box._keydownHandler = keydownHandler;
          });
        }

        // Add window resize listener to update mobile detection
        if (!this._resizeHandler) {
          this._resizeHandler = () => {
            const newIsMobile = window.innerWidth <= 768;
            if (newIsMobile !== isMobile) {
              this.setupChoiceBoxes();
            }
          };
          window.addEventListener('resize', this._resizeHandler);
        }
      });
    },
  },
  mounted() {
    this.getBallotData();
    // this.setupChoiceBoxes();

    // Add resize listener for responsive behavior
    window.addEventListener('resize', () => {
      // this.setupChoiceBoxes();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.setupChoiceBoxes();
    });
  },

  beforeDestroy() {
    // Clean up event listeners
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
  }

};
</script>



// WEBPACK FOOTER //
// src/PracticeBallotV2.vue